<template>
    <a
      class="nav-link"
      :class="{ 'active': customizer == 'settings' }"
      id="c-pills-home-tab" data-bs-toggle="pill" role="tab" aria-controls="c-pills-layouts" :aria-selected="customizer == 'settings' ? 'true' : 'false' " data-original-title title
      @click="openCustomizerSetting('settings')"
      href="javascript:void(0)"
    >
      <div class="settings">
        <i class="icon-settings customizer-icon-color"></i>
      </div>

    </a> 
  </template>
  
  <script>
    import { mapState } from 'vuex';
  
    export default {
      name: 'customizerOpen',
      computed: {
        ...mapState({
          customizer: (state) => state.menu.customizer,
        }),
      },
      methods: {
        openCustomizerSetting(val) {
          this.$store.state.menu.customizer = val;
        },
      },
    };
  </script>